import { Camelized } from 'humps';
import { sdk } from 'src/utilities/sdk';
import {
  CateringServiceFeeResponse,
  CateringServiceFeePayloadUI,
} from 'src/types/CateringServiceFee';
import {
  camelizeResponseData,
  decamelizeRequestBody,
} from 'src/utilities/http-data-casing';

export const getFeeServiceFeeUrl = (corpId: string): string =>
  `/corps/${corpId}/fees`;
export const SET_CATERING_SERVICE_FEE_URL = '/corps/fees';

export async function getCateringServiceFee(
  corpId: string
): Promise<Camelized<CateringServiceFeeResponse>> {
  const url = getFeeServiceFeeUrl(corpId);
  const data = await sdk.http.get(url);
  return camelizeResponseData(data);
}

export async function setCateringServiceFee(
  payload: CateringServiceFeePayloadUI
): Promise<Camelized<CateringServiceFeeResponse>> {
  const data = await sdk.http.post(
    SET_CATERING_SERVICE_FEE_URL,
    decamelizeRequestBody(payload)
  );
  return camelizeResponseData(data);
}
